import PlpHeader from './PlpHeader';

export default PlpHeader;
